// generators/generateMoneyMath.js
export function generateMoneyMath() {
  const templates = [
    // Simple change
    () => {
      const paid = rand(5, 20), cost = rand(1, paid - 1);
      return {
        text: `You pay $${paid} for a toy that costs $${cost}. How much change do you get?`,
        answer: paid - cost
      };
    },
    // Total cost
    () => {
      const n = rand(2, 6), price = rand(2, 9);
      return {
        text: `A pen costs $${price}. You buy ${n} pens. What is the total cost?`,
        answer: n * price
      };
    },
    // How many can you buy
    () => {
      const money = rand(10, 40), price = rand(2, 6);
      return {
        text: `You have $${money}. Each notebook costs $${price}. How many notebooks can you buy?`,
        answer: Math.floor(money / price)
      };
    },
    // Coins and bills
    () => {
      const quarters = rand(4, 20), dimes = rand(3, 12);
      return {
        text: `You have ${quarters} quarters and ${dimes} dimes. How much money do you have? (in dollars)`,
        answer: (quarters * 0.25 + dimes * 0.10).toFixed(2)
      };
    },
    // Static/fun
    () => ({
      text: "If you save $2 every day for a week, how much money will you have at the end?",
      answer: 14
    }),
    // Add 40+ more as above
    // ...
  ];

  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  return templates[Math.floor(Math.random() * templates.length)]();
}
